import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Button,
  Typography,
  Box,
  IconButton,
  FormGroup,
  FormControlLabel,
  Autocomplete,
  MenuItem,
} from "@mui/material";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import LoaderBackdrop from "../../Components/Loader/LoaderBackdrop";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import SaveIcon from "@mui/icons-material/Save";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import UpdateIcon from "@mui/icons-material/Update";
import "react-quill/dist/quill.snow.css";
import IOSSwitch from "../../Components/Buttons/IOSSwitch";
import configServ from "../../services/config";
import Swal from "sweetalert2";
import DailyUrlTable from "./DailyUrlTable";
// import KuldeviAdditionTable from "./KuldeviAdditionTable";
const DailyPageUrl = () => {
  const { company_id, user_id } = useSelector((state) => state.GlobalVariables);
  const [backDrowLoading, setBackDrowLoading] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [podcastUser, setPodcastUser] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);

  const [formData, setFormData] = useState({
    title: "",
    author_id: "",
    category_id: "",
    daily_url: "",

    active: true,
  });
  const [validationErrors, setValidationErrors] = useState({});

  const handlePopup = () => {
    setIsCreate(!isCreate);
    setIsEdit(false);
    clear();
  };

  // 🔹 Handle field change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const clear = () => {
    setFormData({
      title: "",
      author_id: "",
      category_id: "",
      daily_url: "",
      active: true,
    });

    setValidationErrors({});

    setIsEdit(false);
  };

  const handleSubmit = async () => {
    // console.log("Form Data Submitted:", formData);
    const errors = {};

    // 🔹 Validation
    if (!formData.title?.trim()) {
      errors.title = "Title is required";
    }

    if (!formData.author_id) {
      errors.author_id = "Please select an Author";
    }

    if (!formData.category_id) {
      errors.category_id = "Category is required";
    }

    if (!formData.daily_url?.trim()) {
      errors.daily_url = "Daily URL is required";
    } else {
      const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?$/i;
      if (!urlPattern.test(formData.daily_url.trim())) {
        errors.daily_url =
          "Please enter a valid URL (e.g. https://example.com)";
      }
    }

    // If any validation fails → show errors and stop
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    // Clear previous errors
    setValidationErrors({});
    setBackDrowLoading(true);

    try {
      let res;

      // 🔹 For Edit
      if (isEdit) {
        res = await configServ.updateDailyUpdate({
          ...formData,
          company_id,
          updated_by: user_id,
        });
      }
      // 🔹 For Create
      else {
        res = await configServ.storeDailyUpdate({
          ...formData,
          company_id,
          created_by: user_id,
        });
      }

      // 🔹 On Success
      if (res.success) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text:
            res.message || (isEdit ? "Daily Url updated!" : "Daily url added!"),
          timer: 2000,
          showConfirmButton: false,
        });

        clear();
        setIsCreate(false);
        fetchKuldeviTable(); // 🔁 Refresh table or list
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Something went wrong!",
      });
    } finally {
      setBackDrowLoading(false);
    }
  };

  // ✅ Add English + Hindi font families

  // 🔹 Dummy Data for dropdowns (later API-based)

  const fetchPodcastUser = async () => {
    try {
      setBackDrowLoading(true);
      const res = await configServ.getResourceMasterUserByCompany(company_id);
      if (res.success) {
        setPodcastUser(res.data); // make sure you have state: const [podcastList, setPodcastList] = useState([]);
      } else {
        console.error("Failed to fetch podcasts:", res.data.message);
      }
    } catch (error) {
      console.error("API error:", error);
    } finally {
      setBackDrowLoading(false);
    }
  };
  useEffect(() => {
    if (isCreate) {
      fetchPodcastUser();
    }
  }, [isCreate]);

  const highlightMatch = (text, query) => {
    try {
      const words = query.toLowerCase().split(" ").filter(Boolean);
      const regex = new RegExp(`(${words.join("|")})`, "gi");

      return text.split(regex).map((part, index) =>
        words.includes(part.toLowerCase()) ? (
          <mark key={index} style={{ backgroundColor: "#ffe58f" }}>
            {part}
          </mark>
        ) : (
          <React.Fragment key={index}>{part}</React.Fragment>
        )
      );
    } catch (e) {
      console.error("Error in highlightMatch:", e);
      return text;
    }
  };

  const handleEdit = async (item) => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    try {
      //   console.log("onEdit =", item);
      window.scrollTo({ top: 0, behavior: "smooth" });

      setIsCreate(true);
      setIsEdit(true);

      setFormData({
        id: item.id,
        title: item.title || "",
        author_id: item.author_id || "",
        category_id: item.category_id || "",
        daily_url: item.daily_url || "",
        active: item.active === 1 || item.active === true ? true : false,
      });
    } catch (error) {
      console.error("Error fetching Kuldevi photos:", error);
    }
  };

  const fetchKuldeviTable = () => {
    setRefreshKey((prev) => prev + 1); // trigger child refresh
  };

  return (
    <>
      <LoaderBackdrop open={backDrowLoading} />
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Daily URL"}
        handlePopup={handlePopup}
        create={isCreate}
        isEdit={isEdit}
      />

      {isCreate && (
        <motion.div
          style={{
            width: "100%",
            backgroundColor: "#e3f3fc",
            padding: 20,
            borderRadius: "10px",
          }}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.1, delay: 0.1 }}
        >
          <Grid container spacing={2}>
            {/* 🟦 Title */}
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="small"
                label="Title"
                name="title"
                onChange={handleChange}
                value={formData.title}
                sx={{ backgroundColor: "white" }}
                error={!!validationErrors.title}
                helperText={validationErrors.title}
              />
            </Grid>

            {/* category id */}

            <Grid item xs={12} md={4}>
              <TextField
                select
                fullWidth
                size="small"
                label="Category"
                name="category_id"
                value={formData.category_id || ""}
                onChange={handleChange}
                sx={{ backgroundColor: "white" }}
                error={!!validationErrors.category_id}
                helperText={validationErrors.category_id}
              >
                {[
                  { value: "14", label: "Numerology" },
                  { value: "11", label: "Vastu" },
                  { value: "16", label: "Astrology" },
                  //   { value: "4", label: "Cultural" },
                ].map((cat) => (
                  <MenuItem key={cat.value} value={cat.value}>
                    {cat.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* 🟨 Author Autocomplete */}
            <Grid item xs={12} md={4}>
              <Autocomplete
                disablePortal
                fullWidth
                size="small"
                id="author_id"
                name="author_id"
                options={podcastUser}
                getOptionLabel={(option) => option.name || ""}
                filterOptions={(options, { inputValue }) => {
                  const words = inputValue
                    .toLowerCase()
                    .split(" ")
                    .filter(Boolean);
                  return options.filter((item) =>
                    words.every((word) =>
                      item.name.toLowerCase().includes(word)
                    )
                  );
                }}
                sx={{ background: "white" }}
                value={
                  podcastUser.find((item) => item.id === formData.author_id) ||
                  null
                }
                onChange={(event, newValue) => {
                  if (newValue) {
                    setFormData((prev) => ({
                      ...prev,
                      author_id: newValue.id,
                    }));
                  }
                }}
                renderInput={(params) => {
                  const inputValue = params.inputProps.value || "";
                  const doesNotMatchOption =
                    inputValue &&
                    !podcastUser.some((item) =>
                      inputValue
                        .toLowerCase()
                        .split(" ")
                        .filter(Boolean)
                        .every((word) => item.name.toLowerCase().includes(word))
                    );

                  return (
                    <Box display="flex" alignItems="center" width="100%">
                      <TextField
                        {...params}
                        label="Select Author"
                        name="author_id"
                        error={!!validationErrors.author_id}
                        fullWidth
                      />
                    </Box>
                  );
                }}
                renderOption={(props, option, { inputValue }) => (
                  <li {...props}>
                    <Typography variant="body2">
                      {highlightMatch(option?.name, inputValue)}
                    </Typography>
                  </li>
                )}
              />
            </Grid>

            {/* 🟦 daily_url */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                label="Daily Url"
                name="daily_url"
                onChange={handleChange}
                value={formData.daily_url}
                sx={{ backgroundColor: "white" }}
                error={!!validationErrors.daily_url}
                helperText={validationErrors.daily_url}
              />
            </Grid>

            {/* 🔘 Active Switch */}
            <Grid item xs={12} md={3}>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={formData.active}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          active: e.target.checked,
                        }))
                      }
                      name="active"
                    />
                  }
                  label="Active"
                />
              </FormGroup>
            </Grid>
          </Grid>

          {/* Buttons */}
          <Grid container spacing={2} justifyContent="flex-end" mt={2}>
            <Grid item>
              <Button
                onClick={clear}
                variant="contained"
                color="secondary"
                startIcon={<RotateLeftIcon />}
              >
                Reset
              </Button>
            </Grid>
            <Grid item>
              <Button
                onClick={handleSubmit}
                variant="contained"
                color={isEdit ? "success" : "primary"}
                startIcon={isEdit ? <UpdateIcon /> : <SaveIcon />}
              >
                {isEdit ? "Update" : "Save"}
              </Button>
            </Grid>
          </Grid>
        </motion.div>
      )}
      <DailyUrlTable handleEdit={handleEdit} refreshKey={refreshKey} />
    </>
  );
};

export default DailyPageUrl;
